<div class="page bg-bluegray-50">
  <div class="page-title">
    <div class="flex bg-bluegray-50 justify-content-between">
      <div class="flex align-items-center justify-content-center gap-1">
        <div #refHeader>
          <ng-content class="p-2" select="[header]"></ng-content>
        </div>
        <ng-container *ngIf="!refHeader.childElementCount && pageTitle" class="flex align-items-center px-2 w-full">
          <app-button *ngIf="canShowBreadcrumb!=false" (click)="goBack()" [disabled]="disableBackButton()" color="primary" icon="chevron_left" style="width: 40px !important;"></app-button>
          <!-- <mat-icon *ngIf="pageIcon" class="material-symbols-outlined text-gray-700">{{pageIcon}}</mat-icon>
          <span class="text-xs font-light uppercase">
            {{ pageTitle }}
          </span>
          <span *ngIf="info" class="ml-2 text-xs font-medium uppercase">
            {{ info }}
          </span> -->
          <app-breadcrumb *ngIf="canShowBreadcrumb!=false" ></app-breadcrumb>
        </ng-container>
      </div>
      <div class="flex align-items-center">
        <ng-content select="[top-right]"></ng-content>
      </div>
    </div>
  </div>
  <div [class]="'page-content border-round-top-xl surface-50 border-top-1 border-left-1 border-200 p-'+padding">
    <ng-content></ng-content>
  </div>
  <div class="page-footer surface-50 border-left-1 border-200">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
